import { getStory } from '@monoimin/storyblok/getStory';

import type {
  EnOrRuLocale,
  LocalizedSlugPageProps,
  RealEstateCountryStoryblok,
} from '@monoimin/sb-types';

/**
 * Используем для получения стори страны и типа объекта в проектах imin и passportivity
 * @param params - Параметры динамической страницы.
 * @param isPropertyType - Определяем путь до стори на основе этого параметра.
 */
export async function getCountryStory(
  preview: boolean,
  params: Awaited<
    LocalizedSlugPageProps<string[], object, EnOrRuLocale>['params']
  >,
  projectFolder: 'immigrantinvest' | 'passportivity-com',
  isRoot?: boolean
) {
  const { slug, locale } = params;

  const path = isRoot
    ? `${projectFolder}/${locale}/real-estate-country/${slug[0]}`
    : `${projectFolder}/${locale}/real-estate-country/${slug[0]}/${slug[1]}`;

  const {
    data: { story },
  } = await getStory<RealEstateCountryStoryblok>(path, {
    version: preview ? 'draft' : 'published',
  });

  return story;
}

export default getCountryStory;
